import { estimatorUrlFor } from './links.js';
import { signOutEverywhere } from './auth.js';

export function initAppSwitch() {
  const nav = document.getElementById('app-switch');
  const link = document.getElementById('to-estimator');
  const out = document.getElementById('sign-out');
  if (!nav || !link || !out) return;
  const href = estimatorUrlFor(location.hostname);
  if (href) link.href = href; else link.remove();
  out.addEventListener('click', () => { signOutEverywhere(); });
  nav.hidden = false;
}
